export default {
  init () {},
  finalize() {
    var $podcastGrid = $('.podcast-list__wrap').imagesLoaded(function () {
      $podcastGrid.masonry({
        columnWidth: '.podcast-card',
        itemSelector: '.podcast-card',
        percentPosition: true,
        stagger: 30,
        // nicer reveal transition
        visibleStyle: {transform: 'translateY(0)', opacity: 1},
        hiddenStyle: {transform: 'translateY(100px)', opacity: 0},
      });
    });
  },
}
